import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { SnackbarType } from './snackbar-type.model';
import { SnackbarAction } from './snackbar-action.model';

@Component({
  selector: 'aipb-snackbar-loading',
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './snackbar-loading.component.html'
})
export class SnackbarLoadingComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: {
      message: string;
      type: SnackbarType;
      action?: SnackbarAction;
    }
  ) {}

  get message(): string {
    return this.data.message;
  }
}
